import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const CompareImport = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <g>
      <path d="M7.872 14H4.128A2.13 2.13 0 0 0 2 16.128v3.744A2.13 2.13 0 0 0 4.128 22h3.744A2.13 2.13 0 0 0 10 19.872v-3.744A2.13 2.13 0 0 0 7.872 14ZM8 19.872c0 .07-.058.128-.128.128H4.128A.128.128 0 0 1 4 19.872v-3.744c0-.07.058-.128.128-.128h3.744c.07 0 .128.058.128.128v3.744Z" />
      <path d="M9.536 2.464a1 1 0 0 1 0 1.415L7.414 6l2.122 2.121A1 1 0 0 1 8.12 9.536L6 7.414 3.879 9.536A1 1 0 0 1 2.464 8.12L4.586 6 2.464 3.879A1 1 0 1 1 3.88 2.464L6 4.586l2.121-2.122a1 1 0 0 1 1.415 0Z" />
      <path d="M19.293 9.707 20.586 11H13v2h7.586l-1.293 1.293a1 1 0 1 0 1.414 1.414l3-3a.997.997 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414Z" />
      <circle cx="13" cy="12" r="1" />
    </g>
  </SvgIcon>
);

export default CompareImport;
